import { createFileRoute } from '@tanstack/react-router';

import { UpdateEventPage } from '~features/events/ui/update-event-page';

export const Route = createFileRoute('/_auth/_layout/events/$eventId/update')({
  component: UpdateEventPage,
});
